import { NgModule } from '@angular/core';
import { Routes, RouterModule} from '@angular/router';
import { Error404Component } from './modules/error404/error404.component';


const routes: Routes = [
	{
		path: '',
		loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule)
	},
	{
		path: 'contact-us',
		loadChildren: () => import('./modules/contact/contact.module').then(m => m.ContactModule)
	},
	{
		path: 'faq',
		loadChildren: () => import('./modules/faq/faq.module').then(m => m.FaqModule)
	},
	{
		path: 'blogs',
		loadChildren: () => import('./modules/blog/blog.module').then(m => m.BlogModule)
	},
	{
		path: 'employers',
		loadChildren: () => import('./modules/employer_listing/employer_listing.module').then(m => m.EmployerListingModule)
	},
	{
		path: 'resume_writers',
		loadChildren: () => import('./modules/resume_writers_listing/resume_writers_listing.module').then(m => m.ResumeWritersListingModule)
	},
	{
		path: 'jobs',
		loadChildren: () => import('./modules/job_listing/job_listing.module').then(m => m.JobListingModule)
	},
	{
		path: 'jobs-map-view',
		loadChildren: () => import('./modules/job_listing_map_view/job_listing_map_view.module').then(m => m.JobListingMapViewModule)
	},	
	{
		path: 'resume-writer',
		loadChildren: () => import('./modules/resume_writer/resume_writer.module').then(m => m.ResumeWriterModule)
	},
	{
		path: 'thank-you',
		loadChildren: () => import('./modules/thankyou/thankyou.module').then(m => m.ThankYouModule)
	},
	{
		path: 'success',
		loadChildren: () => import('./modules/success/success.module').then(m => m.SuccessModule)
	},
	{
		path: 'terms-condition',
		loadChildren: () => import('./modules/cms/cms.module').then(m => m.CmsModule),
		data:{'slug':'terms-condition'}
	},
	{
		path: 'about-us',
		loadChildren: () => import('./modules/cms/cms.module').then(m => m.CmsModule),
		data:{'slug':'about-us'}
	},
	{
		path: 'featured-amenity',
		loadChildren: () => import('./modules/cms/cms.module').then(m => m.CmsModule),
		data:{'slug':'featureing-amenity'}
	},
	{
		path: 'privacy-policy',
		loadChildren: () => import('./modules/cms/cms.module').then(m => m.CmsModule),
		data:{'slug':'privacy-policy'}
	},
	{
		path: 'trust-and-safety',
		loadChildren: () => import('./modules/cms/cms.module').then(m => m.CmsModule),
		data:{'slug':'trust-and-safety'}
	},
	{
		path: 'fraud-alert',
		loadChildren: () => import('./modules/cms/cms.module').then(m => m.CmsModule),
		data:{'slug':'fraud-alert'}
	},
	{
		path: 'categories',
		loadChildren: () => import('./modules/category_listing/category_listing.module').then(m => m.CategoryModule)
	},	
	{
		path: 'employer',
		loadChildren: () => import('./modules/employer/employer.module').then(m => m.EmployerModule)
	},	
	{
		path: 'jobseeker',
		loadChildren: () => import('./modules/jobseeker/jobseeker.module').then(m => m.JobseekerModule),       
	},	
	{
		path: 'subscription_plan',
		loadChildren: () => import('./modules/subscription_plan/subscription_plan.module').then(m => m.SubscriptionModule)  
	},
	{
		path: 'resumes',
		loadChildren: () => import('./modules/resume_listing/resume_listing.module').then(m => m.ResumeListingModule)  
	},
	{
		path: 'resume-preview',
		loadChildren: () => import('./modules/resume_preview/resume_preview.module').then(m => m.ResumePreviewModule)  
	},
	{
		path: 'unsubscribe',
		loadChildren: () => import('./modules/unsubscribe/unsubscribe.module').then(m => m.UnsubscribeModule)  
	},
	//~ {
		//~ path: 'chat',
		//~ loadChildren: () => import('./modules/chat/chat.module').then(m => m.ChatModule)
	//~ },
	{
		path: '404', component: Error404Component
	},
	{
		path: '**', component: Error404Component
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			initialNavigation: 'enabled'
		})
	],
	exports: [RouterModule]
})
export class AppRoutingModule { }
